import { render, staticRenderFns } from "./CVsJob.vue?vue&type=template&id=4fa433d7"
import script from "./CVsJob.vue?vue&type=script&lang=js"
export * from "./CVsJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports